var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolTreeDownFieldObs = function SvgFiremapSymbolTreeDownFieldObs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#firemap-symbol-tree-down-field-obs_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m2 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12M12.66 4c-.48 0-.911.214-1.202.55a1.583 1.583 0 0 0-2.496 1.293c0 .456.193.867.502 1.155a1.582 1.582 0 0 0 .827 3.039 1.444 1.444 0 0 0 .505 1.26l-.77 1.044-2.521 1.685-2.265-.177 1.524 1.521.212 1.025h.71l.179.434H5v1.054h14v-1.054H8.466V15.37l2.64-2.615.848-.837a1.583 1.583 0 0 0 1.81 2.064 1.453 1.453 0 0 0 2.774.124A1.715 1.715 0 0 0 19 12.563c0-.714-.439-1.327-1.062-1.583.327-.29.534-.713.534-1.183 0-.816-.62-1.487-1.415-1.572a1.582 1.582 0 0 0-.965-2.028l.003-.09a1.319 1.319 0 0 0-1.975-1.144A1.585 1.585 0 0 0 12.66 4",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "firemap-symbol-tree-down-field-obs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgFiremapSymbolTreeDownFieldObs;